import { Component, Input, OnInit } from '@angular/core';
import { ViewChild, ElementRef } from '@angular/core';
import { NgForm } from '@angular/forms';
import { FormComponent } from '../../../../../models/FormComponent';
import { Product } from '../../../../../models/Product';
import { ProductValidatorService, ValidationErrorSettings } from "../../../../../services/validators/product-validator.service";
import { HtmlHelperService } from "../../../../../services/utility/html-helper.service";

@Component({
  selector: 'app-ape-description',
  templateUrl: './ape-description.component.html',
  styleUrls: ['./ape-description.component.scss']
})
export class ApeDescriptionComponent extends FormComponent implements OnInit {
  @Input('product') product: Product; //assigned a COPY so that original is maintained to check diff.
  @ViewChild('formElement') formElement:ElementRef;
  @ViewChild('formData') formData:NgForm;
  get fieldId():string { return '#'+this.formData.name }
  get fieldValue():string { return this.formData.value as string }

  constructor(
    private _productValidator:ProductValidatorService,
    private htmlHelper:HtmlHelperService,
  ) { super() }

    ngOnInit() {
    let validationErrorSettings:ValidationErrorSettings = {fieldNameForMessage:'Description', required:false, minlength:5}
    this.initParent(this.product, this.formElement, this.formData, this._productValidator, validationErrorSettings);
  }

  //need to override parent's function, to adjust height of textarea
  onFormChange($e){
    super.onFormChange($e);  //call parent
    //textarea: use htmlHelper to adjust size after initial blur
    if(this.formData.touched){
      let elementId = this.formData.name;  //elementid without the hash
      this.htmlHelper.adjustHeightSingleTextarea(elementId);
    }  
  }


}



// WEBPACK FOOTER //
// ./src/app/components/admin/admin-products/admin-product-edit/ape-description/ape-description.component.ts